/**
 * Профиль пользователя для тестового режима (вход по `secret-dreamlab`).
 *
 * Пользователь панели — аким Атырауской области.
 * Источник: указ Президента РК от 17.07.2026 (akorda.kz) —
 * Акчулаков Болат Уралович.
 *
 * Реальный пользователь приходит из `/users/me` после настоящего входа;
 * эти значения видны в тестовом режиме и как fallback в шапке.
 *
 * Портрет — Wikimedia Commons (см. public/portraits/ATTRIBUTION.txt).
 */
export const dashboardProfileMock = {
  lastName: 'Акчулаков',
  firstName: 'Болат',
  middleName: 'Уралович',
  fullName: 'Акчулаков Болат Уралович',
  position: 'Аким\nАтырауской области',
  avatar: '/portraits/akchulakov.jpg',
  email: 'obl.akimat@atyrau.gov.kz',
  phone: '+7 (7122) 35-40-92',
  department: 'Аппарат акима области',
  location: 'г. Атырау',
}
